const TAGS = {
  ALL_TAGS_ID: 'all-tags',
  ALL_TAGS_LABEL: 'All tags',
  ALL_TAGS_OPTION: { name: 'All tags', value: { id: 'all-tags', label: 'All tags' } },
};

export default TAGS;
